import styled, { css } from "styled-components";
import { theme } from "../../../config";
import { Props } from "./ApplicantFormSuccess";

export const Main = styled.div`
  ${theme.mainContainerStyle}

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  @media ${theme.breakpoints.mobile} {
    overflow-x: hidden;
    ${theme.hideScrollbar}
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const Container = styled.div`
  ${theme.defaultContainerBoxShadow};
  background: ${theme.colors.white};
  text-align: center;
  width: 620px;
  height: 670px;

  @media ${theme.breakpoints.mobile} {
    height: 100%;
  }
`;

export const HeaderText = styled.h5`
  padding: 47px 0 20px 0;
  font-weight: bold;
  font-size: 34px;
  line-height: 48px;
  font-family: Orkney Bold;

  @media ${theme.breakpoints.mobile} {
    font-size: 21.6px;
    line-height: 26px;
  }
`;

export const BodyWrapper = styled.div`
  margin: 0 101px;
  @media ${theme.breakpoints.mobile} {
    margin: 0 34px;
  }
`;

export const MailImage = styled.img`
  margin-top: 30px;
  margin-bottom: 47px;

  @media ${theme.breakpoints.mobile} {
    height: 100px;
  }
`;

const TextStyle = css`
  font-size: 16px;
  font-weight: 400;
  line-height: 21px;

  @media ${theme.breakpoints.mobile} {
    font-size: 14px;
  }
  & span {
    display: none;
  }
`;

export const Text1 = styled.p`
  ${TextStyle}
  &:after {
    content: "${(props: Props) => props.firstText}";

    @media ${theme.breakpoints.mobile} {
      content: "${(props: Props) => props.firstTextMobile}";
    }
  }
`;

export const Text2 = styled.p`
  ${TextStyle}
  &:after {
    content: "${(props: Props) => props.secondText}";

    @media ${theme.breakpoints.mobile} {
      content: "${(props: Props) => props.secondTextMobile}";
    }
  }
`;

export const Logo = styled.img`
  margin-top: 40px;
  height: 35px;

  @media ${theme.breakpoints.mobile} {
    height: 24px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 48px;
  }
`;
